










import { Component, Vue } from 'vue-property-decorator';
import paycheckSettingsService from '@/utils/paycheck-settings-service';
import { onLogout as vueApolloLogout } from '@/utils/vue-apollo';

@Component
export default class LogoutButton extends Vue {
  private loggingOut = false;

  private logout() {
    this.loggingOut = true;

    paycheckSettingsService.clearExpandedSections();
    vueApolloLogout();
  }
}
